import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { site } from "../mock";

export default function MentionsLegales() {
  return (
    <div>
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow text-center max-w-3xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Informations légales</p>
          <h1 className="font-display text-4xl md:text-5xl gold-gradient-text">Mentions légales</h1>
          <div className="gold-divider my-5 max-w-[220px] mx-auto" />
        </div>
      </section>

      <section className="py-14 bg-charcoal">
        <div className="container-narrow max-w-3xl space-y-8">
          <Block titre="Éditeur du site">
            <p>Le présent site est édité par <span className="text-gold">{site.name}</span>, marabout voyant médium et guérisseur, exerçant en tant qu'indépendant.</p>
            <p>Adresse du cabinet : {site.address}</p>
            <p>Téléphone : <a className="text-gold hover:underline" href={`tel:${site.phoneRaw}`}>{site.phone}</a></p>
            <p>WhatsApp : <a className="text-gold hover:underline" href={site.whatsapp} target="_blank" rel="noreferrer">{site.phone}</a></p>
          </Block>

          <Block titre="Hébergement">
            <p>Ce site est hébergé par un prestataire technique respectueux du RGPD, dont les serveurs sont situés dans l'Union européenne.</p>
          </Block>

          <Block titre="Propriété intellectuelle">
            <p>L'ensemble des contenus présents sur ce site (textes, images, logos, mise en page, code) sont la propriété exclusive de {site.name}. Toute reproduction, même partielle, sans autorisation écrite préalable est strictement interdite.</p>
          </Block>

          <Block titre="Nature des prestations">
            <p>Les prestations proposées par {site.name} relèvent de la <span className="text-gold">tradition spirituelle africaine</span> : voyance, médiumnité, rituels de magie blanche, désenvoûtement, soins énergétiques. Elles ne se substituent en aucun cas à un avis médical, psychologique, juridique ou financier.</p>
            <p>Les résultats des travaux spirituels dépendent de nombreux facteurs (réceptivité, contexte, temporalité). Aucune obligation de résultat ne peut être exigée ; l'engagement porte sur les moyens mis en œuvre.</p>
          </Block>

          <Block titre="Confidentialité">
            <p>Toute personne consultant ou correspondant avec {site.name} bénéficie d'une <span className="text-gold">confidentialité absolue</span>. Aucune information personnelle n'est partagée avec un tiers.</p>
          </Block>

          <Block titre="Données personnelles (RGPD)">
            <p>Les données collectées via le formulaire de contact (nom, téléphone, ville, message) sont utilisées uniquement dans le cadre du traitement de votre demande. Elles ne sont ni revendues, ni transmises à des tiers commerciaux.</p>
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez le cabinet au {site.phone}.</p>
          </Block>

          <Block titre="Cookies">
            <p>Ce site n'utilise que des cookies techniques indispensables à son bon fonctionnement. Aucun cookie publicitaire ou de suivi tiers n'est déposé sans votre consentement explicite.</p>
          </Block>

          <Block titre="Règlement des consultations">
            <p>Les honoraires sont annoncés clairement avant chaque prestation. La première prise de contact par téléphone ou WhatsApp est gratuite. Les modes de paiement acceptés sont précisés au moment de la réservation.</p>
          </Block>

          <Block titre="Public concerné">
            <p>Les prestations spirituelles proposées sur ce site sont réservées à un public majeur (18 ans et plus).</p>
          </Block>

          <Block titre="Droit applicable">
            <p>Le présent site et les prestations qui y sont proposées sont soumis au droit français. En cas de litige, compétence est donnée aux tribunaux du ressort d'Orléans.</p>
          </Block>
        </div>
      </section>
      <Footer />
    </div>
  );
}

function Block({ titre, children }) {
  return (
    <div className="card-onyx rounded-xl p-6">
      <h2 className="font-display text-xl text-gold mb-3">{titre}</h2>
      <div className="space-y-2 text-sm text-gold-soft/95 leading-relaxed">{children}</div>
    </div>
  );
}
